<template>
	<div class="language_template">
		<el-select ref="elSelect" @mouseenter="showDropdown" @mouseleave="hideDropdown" v-model="language" ::popper-visibl="dropdownVisible" :class="no_icon_select ? 'no_icon_select' : '' " @change="set_language()">
		  <el-option v-for="(item, index) in language_list" :key="item.id" :label="item.label[language]" :value="item.value" ></el-option>
		</el-select>
	</div>
</template>

<script>

export default {
	name: 'language',

	// props: {
	// 	Post_List: {
	// 		type: Array,
	// 		default: []
	// 	},
	// },
	data() {
		return {
			language: "en",
			no_icon_select: true,
			dropdownVisible: false, // 控制下拉框的显示与隐藏
			language_list:[
				{
					id:1,
					value: "en",
					label: {
						en: "English",
						es: "Inglés",
						ja: "英語",
						zh: "英语",
					},
				},
				{
					id:2,
					value: "es",
					label: {
						en: "Spanish",
						es: "Español",
						ja: "スペイン語",
						zh: "西班牙语",
					},
				},
				{
					id:3,
					value: "ja",
					label: {
						en: "Japanese",
						es: "Japonés",
						ja: "日本語",
						zh: "日本语",
					},
				},
				// {
				// 	id:4,
				// 	value: "zh",
				// 	label: {
				// 		en: "Chinese",
				// 		es: "Chino",
				// 		ja: "中国語",
				// 		zh: "中文简体",
				// 	},
				// },
			]
		}
	},
	
	// 监听
	watch: {
		"language": {
			handler: function (newValue, oldValue) {
				this.set_language
			},
			deep: true
		},
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		let language = this.get_cookie_name('language')
		if(language){
			this.language = language
		}

		// 精准查找当前组件内下拉输入框
		this.$nextTick(() => {
			this.set_input_label()
		})

		// hover下拉时重新赋值，防止DOM重建丢失属性
		let that = this
		this.$el.addEventListener('mouseenter', () => {
			setTimeout(() => {
				that.set_input_label()
			}, 50)
		})
	},
  
	methods:{
		set_input_label(){
			// 限定.language_template父容器，避免页面其他el-select干扰
			const input = this.$el.querySelector('.language_template .el-input__inner')
			if(input) input.setAttribute('aria-label', 'Switch website display language')
		},
		showDropdown() {
			this.dropdownVisible = true;
		},
		hideDropdown() {
			this.dropdownVisible = false;
		},
		set_language(){
			console.log(this.language)
			// let domain = ".tozostore.com"
			let domain = process.env.domain
		   let locale = this.language
		   locale = locale ? locale : 'en' //没有就默认英文
		   // 获取当前时间
		   var now = new Date();
		   // 设置过期时间为 366 天
		   now.setTime(now.getTime() + 366 * 24 * 60 * 60 * 1000);
		   // 转换为 UTC 字符串
		   var expires = now.toUTCString();
		  
			this.$cookie.set('language', locale, { expires: "366D" })
		   // document.cookie = `language=${locale};domain=${domain};expires=${expires};path=/;secure;SameSite=Lax`;
			console.log(this.language)
			window.location.reload();
			// this.$router.go(0);
			
			// let that = this
			// console.log(this.$route.name)
			// console.log(this.$route.params)
			
			// let routeName = this.$route.name
			// let routeParams = this.$route.params
			// setTimeout(()=>{
			// 	that.$router.push({
			// 		name: routeName ? routeName : "/",
			// 		params: routeParams ? routeParams : ''
			// 	})
			// },500)
		},
		
		get_cookie_name(name){
			let decodedCookies = {};
			let cookieValue = document.cookie;
			if(cookieValue && cookieValue.length != 0){
					cookieValue.split(';').forEach(cookie => {
					let parts = cookie.split('=');
					let key = decodeURIComponent(parts[0].trim()); //decodeURIComponent反转译
					let value = decodeURIComponent(parts[1]);
					decodedCookies[key] = value;
				});
				return decodedCookies[name]
			}else{
			  	return null
			}
		},
	
	}
}
</script>

<style lang="less">
	*{
		box-sizing: border-box;
	}
	.language_template{
		width: auto;
	}
	.no_icon_select .el-input__suffix {
	   /* display: none !important; */
	}
	.no_icon_select.el-select .el-input .el-select__caret{
		color: #333333 !important;
	}
	.no_icon_select .el-select .el-input__inner {
	   cursor: pointer;
	   padding-left: 5px !important;
	   padding-right: 5px !important;
	}
	.no_icon_select .el-input__inner {
	   border: 0px solid #DCDFE6 !important;
	   box-sizing: border-box;
	   color: #333333 !important;
	   font-size: 14px !important;
	   height: 40px;
	   line-height: 1;
	   outline: 0;
	   padding-left: 5px !important;
	   padding-right: 5px !important;
	}
</style>
